import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box } from '@mui/material'
import IconInfo from 'components/Bookings/Confirmation/IconInfo'
import React from 'react'

interface Props {
  data: any
}

const StatusOther: React.FC<Props> = (props) => {
  const { data } = props
  console.log(data)
  return (
    <Box sx={{ display: 'flex' }}>
      <IconInfo
        Icon={InfoOutlinedIcon}
        title="booking reference"
        value={data?.bookingReference}
      />
      <IconInfo
        Icon={InfoOutlinedIcon}
        title="job reference"
        value={data?.jobReference}
      />
    </Box>
  )
}

export default StatusOther
